/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import React from 'react';
// library to set component properties
import PropTypes from 'prop-types';
// lodash wrapper for immutable.js
import { isEmpty, map, filter } from 'lodash';
// @material-ui/core
import Toolbar from '@material-ui/core/Toolbar';
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Dropdown from 'components/Dropdown/Dropdown';
import TimeFilter from 'layout/Filter/TimeFilter';
import { HSpacer } from 'components/Spacer/Spacer';

/**
 * @ignore
 * @name FilterToolbarStyles
 * @description toolbarStyles for Filter component
 */
const toolbarStyles = theme => ({
  root: {
    marginBottom: '13px',
    marginTop: theme.palette.type === 'light' ? '10px' : '0px',
    minHeight: '50px',
    paddingLeft: 0,
    display: theme.palette.type === 'light' && 'flex',
    flexDirection: theme.palette.type === 'light' && 'column',
    paddingRight: theme.palette.type === 'light' && '0px',
    '& div[class*="control"]': {
      width: theme.palette.type === 'light' && '140px'
    },
    '& > div': {
      marginTop: theme.palette.type === 'light' && '10px'
    }
  }
});

const handleChange = (val, key, filters, callback) => {
  if (filters[key].use_value_dropdown) {
    const [valueObject] = filter(
      filters[val.value].options,
      el => el.is_default === true
    );
    const value = {
      [key]: val,
      [val.value]: valueObject
    };
    callback(value);
  } else callback(val, key);
};

/**
 * @class SEFilter
 * @hideconstructor
 * @description Class component for space, time, region global filters
 */
const SEFilter = ({
  classes,
  filters,
  defaultFilters,
  state,
  handleFilterChange,
  initialSelectedDate,
  routeID,
  parentComponentClass,
  dropdownTitleStyles,
  dropdownStyles
}) => (
  <Toolbar className={classes.root}>
    {!isEmpty(filters)
      ? map(defaultFilters, def => {
          const { value: type, label: title } = def;
          if (filters[type]) {
            const {
              options,
              use_toggle: useToggle,
              use_value_dropdown: useValueDropDown
            } = filters[type];
            const value =
              state[type] !== undefined && state[type] !== null
                ? state[type]
                : options.filter(e => e.is_default === true)[0];
            let valueDropDownKey = '';
            let valueDropDownOptions = [];
            let valueDropDownValue = {};
            if (useValueDropDown) {
              const defaultItem =
                state[type] !== undefined && state[type] !== null
                  ? options.filter(e => e === state[type])[0]
                  : options.filter(e => e.is_default === true)[0];
              valueDropDownKey = defaultItem.value;
              valueDropDownOptions = filters[defaultItem.value].options;
              valueDropDownValue =
                state[valueDropDownKey] !== undefined &&
                state[valueDropDownKey] !== null
                  ? state[valueDropDownKey]
                  : valueDropDownOptions.filter(e => e.is_default === true)[0];
            }
            return type === 'fl_date' ? (
              <React.Fragment key={type}>
                <TimeFilter
                  float="left"
                  key={type}
                  useRange={false}
                  options={options}
                  value={value}
                  routeID={routeID}
                  type={type}
                  defaultDateRange={initialSelectedDate}
                  handleDateChange={date =>
                    handleChange(date, 'fl_date', filters, handleFilterChange)
                  }
                  useMenuPortalTarget={false} // this is necessary to show dropdown menu in sidebar
                  parentComponentClass={parentComponentClass}
                  dropdownTitleStyles={dropdownTitleStyles}
                  dropdownStyles={dropdownStyles}
                />
                <HSpacer amount={5} />
              </React.Fragment>
            ) : useToggle ? null : (
              <React.Fragment key={type}>
                <Dropdown
                  title={title}
                  handleValueChange={val =>
                    handleChange(val, type, filters, handleFilterChange)
                  }
                  options={options}
                  value={value}
                  routeID={routeID}
                  type={type}
                  useMenuPortalTarget={false} // this is necessary to show dropdown menu in sidebar
                  dropdownTitleStyles={dropdownTitleStyles}
                  dropdownStyles={dropdownStyles}
                />
                {useValueDropDown ? (
                  <React.Fragment key={type}>
                    <HSpacer amount={5} />
                    <Dropdown
                      handleValueChange={val =>
                        handleChange(
                          val,
                          valueDropDownKey,
                          filters,
                          handleFilterChange
                        )
                      }
                      options={valueDropDownOptions}
                      value={valueDropDownValue}
                      routeID={routeID}
                      type={type}
                      useMenuPortalTarget={false} // this is necessary to show dropdown menu in sidebar
                      dropdownTitleStyles={dropdownTitleStyles}
                      dropdownStyles={dropdownStyles}
                    />
                  </React.Fragment>
                ) : null}
                <HSpacer amount={5} />
              </React.Fragment>
            );
          }
        })
      : null}
  </Toolbar>
);

// component properties
SEFilter.propTypes = {
  /**
   * @type {object}
   * @description Class names of the styles generated with jss
   */
  classes: PropTypes.object.isRequired,
  /**
   * @type {object}
   * @description dropdown filter data
   */
  filters: PropTypes.object.isRequired,
  /**
   * @type {array}
   * @description filter list
   */
  defaultFilters: PropTypes.array.isRequired,
  routeID: PropTypes.string,
  parentComponentClass: PropTypes.string,
  dropdownTitleStyles: PropTypes.object,
  dropdownStyles: PropTypes.object
};

SEFilter.defaultProps = {
  routeID: '',
  parentComponentClass: '',
  dropdownTitleStyles: {},
  dropdownStyles: {}
};

export default withStyles(toolbarStyles)(SEFilter);
